// extracted by mini-css-extract-plugin
export default {"container":"Contact_container__p7MQM","header":"Contact_header__Wn+27","form":"Contact_form__IRNP2"};